import { useMemo } from 'react';
import MojitoServices from 'mojito/services';
import BetslipNotifications from 'modules/betslip-notifications/index.js';
import { isEmpty } from 'mojito/utils';

const { utils: BetslipUtils } = MojitoServices.Betslip;

const BetErrors = ({ errors, mojitoTools }) => {
    const { stringResolver, config } = mojitoTools;
    // At the time of writing we only support unique error codes.
    const uniqueErrors = BetslipUtils.getUniqueErrors(errors);
    const formattedErrors = useMemo(
        () => formatErrors(uniqueErrors, stringResolver),
        [uniqueErrors, stringResolver]
    );

    if (isEmpty(errors)) {
        return null;
    }

    return <BetslipNotifications config={config.betslipNotifications} errors={formattedErrors} />;
};

const formatErrors = (errors, stringResolver) => {
    return errors.map(error => {
        const { code, factor } = error;
        const message = stringResolver.resolveAndFormatString(
            `$BETSLIP.ERRORS.BET_SPECIFIC.${code}`,
            factor
        );
        return { code, message };
    });
};

export default BetErrors;
